import DataLoader from 'dataloader'

import { type VideoDTO } from '../models/Video'
import { request } from '../../global/api/legacyApi'
import {
  type APIResponse,
  HTTPMethod,
} from '../../sharedLegacy/utils/api.types'

type VideoLoaderParams = {
  selection: string
  include_unpublished_p: number
  size: number
}

const videoLoader = new DataLoader(
  async (videoIds: readonly number[]) => {
    const response = await request<APIResponse<VideoDTO[]>>({
      url: '/api/2/photo/list',
      method: HTTPMethod.GET,
      data: {
        selection: videoIds.join(' '),
        include_unpublished_p: 1,
        size: 5000,
      } satisfies VideoLoaderParams,
    })

    const videos = (response.data ?? []).reduce<Record<number, VideoDTO>>(
      (acc, videoDTO) => {
        return { ...acc, [videoDTO.photo_id]: videoDTO }
      },
      {}
    )
    return videoIds.map((id) => videos[id])
  },
  { cache: false }
)

interface ListVideosParams {
  search?: string
  include_unpublished_p?: boolean
  album_id?: number
  p: number
  size: number
}
const listVideos = ({
  search,
  include_unpublished_p,
  album_id,
  p,
  size,
}: ListVideosParams) =>
  request<APIResponse<VideoDTO[]>>({
    url: '/api/2/photo/list',
    method: HTTPMethod.GET,
    data: {
      search,
      include_unpublished_p,
      album_id,
      p,
      size,
    },
  })

export { videoLoader, listVideos }
